/* リンク */

export const LINK_URL = {
  PLICE_LIST:
    "https://galvanized-jewel-836.notion.site/e5e70b9bf4cb4403aac97464b82fb7e8", //<Notion> メニュー・価格一覧
  REGISTER_TRIAL:
    "https://galvanized-jewel-836.notion.site/d9dabae2115b49dea71a0d3fe1bf0b5c", //<Notion> 初回無料トライアルの利用方法
  REQUEST_A_QUOTE:
    "https://galvanized-jewel-836.notion.site/6d58118239b745a392f7d6f45c2f4daa", //<Notion> 見積り依頼一覧
  QUESTIONNAIRE: "https://forms.gle/z5bh6tyPdKSyRfgc6", //<GForm> 依頼者様向けアンケート
  HOWTO_GMAP_LATITUDE:
    "https://galvanized-jewel-836.notion.site/c332ab4b19ab4acf875fd0390ede02a2", //<Notion> 緯度経度の確認方法
  HOWTO_AREA_CALCULATION:
    "https://galvanized-jewel-836.notion.site/fae89cbe0a1e4cd7aceb05bde30ee347", //<Notion> 面積の算出方法
  WORK_FLOW_MANUAL:
    "https://galvanized-jewel-836.notion.site/e07d76f1dbc54f73ad98b9bf6665c11f?pvs=4", //<Notion> 仕事の新規募集の方法
  ABOUT_PLAN_SYSTEM_INTRODUCTION:
    "https://galvanized-jewel-836.notion.site/d63061ce32224830b13a71ca102a8cd3?pvs=4", //<Notion> プラン、システム導入について
  ABOUT_IMPROBLEMENT_ESTIMATION:
    "https://galvanized-jewel-836.notion.site/eff500bf801343babd6684d36d318f84?pvs=4", //<Notion> 異常箇所の改善見積について
  COSOJI_HUB:
    "https://galvanized-jewel-836.notion.site/COSOJI-Hub-5909bfd43004432eaeaaf97d56595d1d"
};
